import { render, staticRenderFns } from "./QuestionsTable.vue?vue&type=template&id=113364be"
import script from "./QuestionsTable.vue?vue&type=script&lang=js"
export * from "./QuestionsTable.vue?vue&type=script&lang=js"
import style0 from "./QuestionsTable.vue?vue&type=style&index=0&id=113364be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports